"use client";

import {
  type GenerateUploadUrl,
  HookFormFileUploadInput
} from "@gettactic/components/src/form/FileUploadInput";
import React from "react";
import type { FieldValues, UseFormReturn } from "react-hook-form";
import { generateTicketUpload } from "@/features/workplace-requests/lib/ticketUpload";

export type { GenerateUploadUrl };

interface FileUploadFieldInputProps {
  form: UseFormReturn<FieldValues>;
  name: string;
  label: string;
  isRequired?: boolean;
  description?: string;
  /**
   * Override the upload endpoint (e.g. guest sharing). Defaults to the authenticated
   * ticket upload endpoint.
   */
  generateUpload?: GenerateUploadUrl;
}

/**
 * Workplace-request `file_upload` field. Thin adapter over the shared
 * {@link HookFormFileUploadInput} that injects the app's upload endpoint.
 */
export const FileUploadFieldInput: React.FC<FileUploadFieldInputProps> = ({
  form,
  name,
  label,
  isRequired = false,
  description,
  generateUpload
}) => (
  <HookFormFileUploadInput
    form={form}
    name={name}
    label={label}
    isRequired={isRequired}
    description={description}
    generateUpload={generateUpload ?? generateTicketUpload}
  />
);
